var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import MuiBadge, { badgeClasses } from '@mui/material/Badge';
import { avatarClasses } from '../avatar/avatar-classes';
import { styled } from '../styled';
export var badgeComponentName = 'QuantumBadge';
export var Badge = styled(MuiBadge, {
    name: badgeComponentName,
    slot: 'Root',
})(function (_a) {
    var _b, _c;
    var children = _a.children;
    return (__assign(__assign({}, (!children && (_b = {},
        _b["& .".concat(badgeClasses.badge)] = {
            position: 'relative',
            transform: 'none',
        },
        _b))), (_c = {}, _c["& .".concat(avatarClasses.root, " + .").concat(badgeClasses.badge)] = {
        background: 'transparent',
    }, _c)));
});
